import { render, staticRenderFns } from "./AdminSuperMapsCenterSettings.vue?vue&type=template&id=5896d285&scoped=true&"
import script from "./AdminSuperMapsCenterSettings.vue?vue&type=script&lang=js&"
export * from "./AdminSuperMapsCenterSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5896d285",
  null
  
)

export default component.exports